import React from "react";
import { AlertTriangle, ShieldCheck, Eye, Info } from "lucide-react";
import { Card, CardContent } from "../ui/card";
import { FactorCards } from "./Factors";
import { Overline, StockHeader, ThesisStrip } from "./Shared";
import { TRIPWIRES } from "./data";

const ST = {
  SAFE: { c: "text-emerald-400 border-emerald-500/40 bg-emerald-500/10", bar: "bg-emerald-500", I: ShieldCheck },
  WATCH: { c: "text-amber-400 border-amber-500/40 bg-amber-500/10", bar: "bg-amber-500", I: Eye },
  NEAR: { c: "text-red-400 border-red-500/40 bg-red-500/10", bar: "bg-red-500", I: AlertTriangle },
  CONTEXT: { c: "text-muted-foreground border-border bg-muted/20", bar: "bg-zinc-500", I: Info },
};

const Meter = ({ progress, bar }) => (
  <div className="relative h-2 rounded-full bg-zinc-800 overflow-hidden" data-testid="kfm-tripwire-distance-meter">
    <div className={`absolute left-0 top-0 h-full ${bar} transition-all`} style={{ width: `${Math.max(progress, 0.03) * 100}%` }} />
    <div className="absolute right-0 top-0 h-full w-0.5 bg-red-400" />
  </div>
);

export default function VariantTripwires() {
  const armed = TRIPWIRES.filter((t) => t.status !== "SAFE" && t.status !== "CONTEXT").length;
  return (
    <div className="space-y-4" data-testid="kfm-variant-e">
      <StockHeader compact />
      <Card data-testid="kfm-variant-e-hero"><CardContent className="pt-5 pb-5">
        <div className="flex flex-wrap items-end justify-between gap-3 mb-4">
          <div>
            <Overline>What would change the view — tripwires on the validated signals</Overline>
            <div className="text-sm mt-1">View holds while all tripwires stay clear · <span className="font-mono text-amber-400">{armed} on watch</span> · each is an alert you can subscribe to</div>
          </div>
          <div className="text-[11px] text-muted-foreground">meter = distance travelled toward the trigger (red tick)</div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
          {TRIPWIRES.map((t) => {
            const s = ST[t.status];
            return (
              <div key={t.id} className="rounded-md border border-border/70 p-4 space-y-2.5" data-testid={`kfm-tripwire-card-${t.id}`}>
                <div className="flex items-center justify-between gap-2">
                  <span className="text-xs font-bold tracking-[0.1em]">{t.name}</span>
                  <span className={`flex items-center gap-1 px-1.5 py-0.5 rounded border text-[10px] font-mono ${s.c}`}><s.I className="w-3 h-3" />{t.status}</span>
                </div>
                <div className="text-[11px] text-muted-foreground">{t.rule}</div>
                <Meter progress={t.progress} bar={s.bar} />
                <div className="flex justify-between font-mono text-[11px]"><span>now {t.now}</span><span className="text-muted-foreground">trigger {t.trigger}</span></div>
                <div className="text-[11px] border-t border-border/40 pt-2 text-foreground/80">If hit: {t.means}</div>
              </div>
            );
          })}
        </div>
      </CardContent></Card>
      <ThesisStrip />
      <FactorCards prefix="kfm-e" />
    </div>
  );
}
